/// <reference path="../_all.ts" />

module product_references {
  'use strict';  
  
  /**
  * http://stackoverflow.com/a/35299103/142679
  */
  function addMonthsUTC(date, count) {
    if (date && count) {
      var m, d = (date = new Date(+date)).getUTCDate()

      date.setUTCMonth(date.getUTCMonth() + count, 1)
      m = date.getUTCMonth()
      date.setUTCDate(d)
      if (date.getUTCMonth() !== m) date.setUTCDate(0)
    }
    return date
  }
  
  export interface IProductReferenceFilter extends ng.IFilterService {
      (name: 'productReferenceFilter'): (references: ProductReference[], filter :ProductReferenceFilterData) => ProductReference[];
  }


  export function ProductReferenceFilter() {

    return function (references : ProductReference[], filter: ProductReferenceFilterData) { //items, search
      references = references || [];
      if (!filter) return references;

      var dateFrom : number = undefined;
      var dateTo : number = undefined;
      if (filter.inUseSince) {
        var months : number =  parseInt(filter.inUseSince.substr(2));
        var filterDate = addMonthsUTC(new Date(), -1 * months).getTime();
        if (filter.inUseSince.substr(0, 2) == "GT") dateFrom = filterDate;
        if (filter.inUseSince.substr(0, 2) == "LT") dateTo = filterDate;
      }
      
      var out = [];
      references.forEach(function (reference) { 
        if ((!filter.Country || reference.CountryName === filter.Country)
          && (!filter.MeasuringTask || reference.MeasuringTask === filter.MeasuringTask)
          && (!filter.Industry || reference.Industry === filter.Industry)
          && (!filter.productName || reference.ProductName === filter.productName)
          && (!dateFrom || (reference.ProductReferenceDate.getTime() - dateFrom) >= 0)
          && (!dateTo || (reference.ProductReferenceDate.getTime() - dateTo) <= 0)) {

          out.push(reference);   
        }
      });
      return out;
    }

  }


}